// Cardholder self-service PIN unlock (DH-2842). Final copy from the BP-129 copy deck.
// Always "unlock", never "unblock" or "reset"; French uses NIP. {time} is the exact
// moment the next unlock becomes available, in the cardholder's local time. {support} is
// how to reach Cardholder Support, matching the Advantage App's wording and order: call
// the phone (where one is published, HRB) or email the white label's support address,
// each a link; "contact Cardholder Support" as plain text when there is no email.
export const pinUnblockEn = {
  'unlock-pin-button': 'Unlock PIN',
  'pin-locked-alert':
    '<b>Your PIN is locked.</b> Your PIN was entered incorrectly too many times, so your card is being declined at ATMs and checkouts. You can unlock it here.',
  'unlock-pin-heading': 'Unlock your PIN',
  'unlock-pin-intro':
    'Your card is locked because your PIN was entered incorrectly too many times.',
  'unlock-pin-lead': 'Here\'s what unlocking does:',
  'unlock-pin-effect-1': 'Clears the failed attempts, so your card works again.',
  'unlock-pin-effect-2':
    '<b>Your PIN stays the same.</b> We don\'t change it and we don\'t show it to you.',
  'unlock-pin-effect-3':
    'If it\'s entered incorrectly again, your card will lock again.',
  'unlock-pin-effect-4': 'You can unlock your PIN once a day.',
  'unlock-pin-confirm-button': 'Unlock PIN',
  'unlock-pin-success-alert':
    '<b>Your PIN is unlocked.</b> Your card will work again with the PIN you already use.',
  'unlock-pin-limit-alert':
    '<b>Your PIN is locked and you\'ve already unlocked it today.</b> You can unlock it again after {time}, or {support} and we\'ll help.',
  'unlock-pin-failed-alert':
    'We couldn\'t unlock your PIN just now. Please try again in a few minutes, or {support} and we\'ll help.',
  'unlock-pin-support-call-email': 'call {phone} or email {email}',
  'unlock-pin-support-email': 'email {email}',
  'unlock-pin-support-team': 'contact Cardholder Support',
};

export const pinUnblockFr = {
  'unlock-pin-button': 'Débloquer le NIP',
  'pin-locked-alert':
    '<b>Votre NIP est bloqué.</b> Votre NIP a été saisi incorrectement trop de fois; votre carte est donc refusée aux guichets automatiques et aux caisses. Vous pouvez le débloquer ici.',
  'unlock-pin-heading': 'Débloquer votre NIP',
  'unlock-pin-intro':
    'Votre carte est bloquée parce que votre NIP a été saisi incorrectement trop de fois.',
  'unlock-pin-lead': 'Voici ce que fait le déblocage :',
  'unlock-pin-effect-1':
    'Efface les tentatives échouées, afin que votre carte fonctionne de nouveau.',
  'unlock-pin-effect-2':
    '<b>Votre NIP demeure le même.</b> Nous ne le modifions pas et nous ne vous le montrons pas.',
  'unlock-pin-effect-3':
    'S\'il est saisi incorrectement de nouveau, votre carte sera bloquée de nouveau.',
  'unlock-pin-effect-4': 'Vous pouvez débloquer votre NIP une fois par jour.',
  'unlock-pin-confirm-button': 'Débloquer le NIP',
  'unlock-pin-success-alert':
    '<b>Votre NIP est débloqué.</b> Votre carte fonctionnera de nouveau avec le NIP que vous utilisez déjà.',
  'unlock-pin-limit-alert':
    '<b>Votre NIP est bloqué et vous l\'avez déjà débloqué aujourd\'hui.</b> Vous pourrez le débloquer de nouveau après {time}, ou {support} et nous vous aiderons.',
  'unlock-pin-failed-alert':
    'Nous n\'avons pas pu débloquer votre NIP pour le moment. Veuillez réessayer dans quelques minutes ou {support} et nous vous aiderons.',
  'unlock-pin-support-call-email': 'appelez le {phone} ou écrivez à {email}',
  'unlock-pin-support-email': 'écrivez à {email}',
  'unlock-pin-support-team': 'communiquez avec le service d\'assistance aux titulaires de carte',
};
